













import { Component, Vue, Prop } from 'vue-property-decorator'
import _ from 'lodash'
import jsonp from 'browser-jsonp'
import { packeryEvents } from 'vue-packery-plugin'
import imagesLoaded from 'vue-images-loaded'

@Component({
  directives: { imagesLoaded }
})
export default class PostsInstagram extends Vue {
  error: string = ''
  feeds = []

  @Prop({ type: String }) token
  @Prop({ type: Number, default: 3 }) count
  @Prop({ type: String }) mediaType
  @Prop({ type: Array, default: () => [] }) tags
  @Prop({ type: String, default: '' }) containerClass

  mounted() {
    this.getUserFeed()
  }

  setLayout() {
    packeryEvents.$emit('layout', this.$refs.packery)
  }

  getUserFeed() {
    jsonp({
      url: `https://api.instagram.com/v1/users/self/media/recent`,
      data: { access_token: this.token, count: this.count },
      error: (error) => { throw error },
      complete: (response) => {
        if (response.meta.code === 400) { this.error = response.meta }
        if (response.meta.code === 200) {
          if (response.meta.code === 200) {
            let { data } = response
            const types = ['image', 'video']

            if (this.mediaType && types.indexOf(this.mediaType) > -1) {
              data = _.filter((data), (item) => this.mediaType === item.type)
            }

            if (this.tags.length) {
              data = _.filter((data), (item) => _.intersection(this.tags, item.tags).length)
            }

            this.feeds = _.slice(_.values(data), 0, this.count)
          }
        }
      }
    })
  }
}
